// extracted by mini-css-extract-plugin
export var copyContent = "FooterCopyLine-module--copyContent--85c7c";
export var copyMenuItem = "FooterCopyLine-module--copyMenuItem--b53c3";
export var root = "FooterCopyLine-module--root--2ac85";